import { OrderStatus } from "../enums/orderStatus";

/**
 * Matches order service rules: line items (scan / manual add) only in these states.
 */
export const ORDER_LINE_ITEM_EDIT_STATUSES: OrderStatus[] = [
  OrderStatus.DRAFT,
  OrderStatus.OFFER_SUGGESTED
];

export const SCANABLE_STATUSES = ORDER_LINE_ITEM_EDIT_STATUSES;
